import type { ComponentType } from "react"
import MoonStarIcon from "@/icons/svg/MoonStar"
import { Sun as SunIcon, Monitor as MonitorIcon } from "lucide-react"
import type { Theme } from "@/components/theme-context"

export const THEME_OPTIONS: { value: Theme; label: string; Icon: ComponentType<{ className?: string }> }[] = [
  { value: "light",  label: "Light",  Icon: SunIcon },
  { value: "dark",   label: "Dark",   Icon: MoonStarIcon },
  { value: "system", label: "System", Icon: MonitorIcon },
]
